/**
 * №16 S4 — the spine strip: segments as one linear road. Completed collapse to a
 * tick; the NOW segment carries the accent ring; a ripe open decision is the warn
 * fork; future segments are dashed. Pure presentation over the instance detail.
 *
 * №16.2.1-C (D-RN2): renders the projection's ONE `state` field. It used to test
 * `status === "completed"` against an engine that writes `"complete"`, so every
 * finished stage drew as `is-future` — the dashed "stages 1-2 read future" David
 * reported. A resolved decision no longer counts as done either: the stage is
 * done when the STAGE is done, and the bar and the body now say the same thing.
 */
import { TickGlyph } from "./wf-glyphs";
import type { DetailSegment } from "../../hooks/use-workflow";

function segClass(s: DetailSegment): string {
  const cls: string[] = ["wf-seg"];
  if (s.hasDecision && s.decision && !s.decision.resolved) cls.push("is-decision");
  if (s.state === "done" || s.state === "skipped") cls.push("is-done");
  else if (s.state === "open") cls.push("is-now");
  else cls.push("is-future");
  if (s.stateIssue) cls.push("is-impossible");   // D-RN4 — never drawn quietly
  return cls.join(" ");
}

export function WorkflowSpine({ segments }: { segments: DetailSegment[] }) {
  return (
    <div className="wf-spine">
      {segments.map((s, i) => {
        const done = s.state === "done" || s.state === "skipped";
        const label = s.hasDecision && s.decision && !s.decision.resolved ? `${s.name}?` : s.name;
        return (
          <div key={s.segmentNo} className={segClass(s)} title={s.stateIssue?.message}>
            <span className="wf-seg__node">
              <span className="wf-seg__dot">{done ? <TickGlyph /> : null}</span>
              {label}
            </span>
            {i < segments.length - 1 ? <span className="wf-seg__rail" /> : null}
          </div>
        );
      })}
    </div>
  );
}
